import React, { useEffect, useRef, useState } from 'react';

/* 은하수 음악대.
 *
 * 이 컴포넌트는 App 의 렌더 분기(renderContent) 바깥에 놓여 탭을 바꿔도 언마운트되지 않는다.
 * 그래서 다른 서비스로 이동해도 음악이 끊기지 않는다. 화면에서 감출 때는 CSS 로만 감추고
 * 그리기를 멈출 뿐, 소리를 내는 객체는 그대로 살아 있다.
 *
 * 엔진(public/galaxy/*.js)은 번들에 넣지 않고 처음 필요할 때 스크립트로 불러온다.
 * 악보 데이터가 190KB 라 초기 로딩을 늦추지 않기 위해서다.
 */

const FILES = [
  'sprites.data.js', 'scores.data.js', 'pixel.js', 'sky.js', 'stage.js',
  'characters.js', 'synth.js', 'conductor.js', 'main.js',
];

let enginePromise = null;

function loadEngine() {
  if (enginePromise) return enginePromise;
  const base = `${process.env.PUBLIC_URL || ''}/galaxy/`;
  enginePromise = FILES.reduce(
    (chain, name) => chain.then(() => new Promise((resolve, reject) => {
      const tag = document.createElement('script');
      tag.src = base + name;
      tag.async = false;
      tag.onload = resolve;
      tag.onerror = () => reject(new Error(`${name} 을 못 불러왔다`));
      document.head.appendChild(tag);
    })),
    Promise.resolve(),
  );
  return enginePromise;
}

// 페이지 전체에서 하나만 존재한다. StrictMode 가 이펙트를 두 번 돌려도 중복 생성되지 않는다.
let band = null;

const GalaxyBand = ({ visible }) => {
  const hostRef = useRef(null);
  const [status, setStatus] = useState({ playing: false, title: '', index: 0 });
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    loadEngine().then(() => {
      if (cancelled || !hostRef.current) return;
      if (!band) {
        band = window.GalaxyBand.mount(hostRef.current, { maxWidth: 820 });
      } else if (band.root.parentNode !== hostRef.current) {
        hostRef.current.appendChild(band.root);
      }
      if (band) band.on(setStatus);
    }).catch((err) => {
      if (!cancelled) setError(err.message);
    });
    return () => { cancelled = true; };   // 언마운트돼도 band 는 그대로 둔다 (음악 유지)
  }, []);

  useEffect(() => {
    if (band) band.setVisible(visible);
  }, [visible]);

  return (
    <>
      <div
        className="galaxy-host"
        ref={hostRef}
        style={{ display: visible ? 'block' : 'none' }}
      />
      {error && visible && <div className="galaxy-error">음악대를 불러오지 못했다: {error}</div>}

      {/* 다른 탭에 있을 때도 연주 중이면 작은 막대로 남아 멈추거나 곡을 넘길 수 있다 */}
      {!visible && status.playing && (
        <div className="galaxy-pill">
          <span className="galaxy-pill-mark">♬</span>
          <span className="galaxy-pill-title">{status.title}</span>
          <button
            type="button"
            aria-label="다음 곡"
            onClick={() => band && band.setPiece(status.index + 1)}
          >
            ▶▶
          </button>
          <button
            type="button"
            aria-label="음악 멈춤"
            onClick={() => band && band.stop()}
          >
            ■
          </button>
        </div>
      )}
    </>
  );
};

export default GalaxyBand;
